/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'

 
export const getAllRouterUserList = createAsyncThunk('application/rputer/getAllRouterUserList', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.router.getRouterAllUsers(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})